import { Link } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { useQuickEdit } from '@/hooks/useQuickEdit';

interface QuickEditWrapperProps {
  href: string;
  label: string;
  children: React.ReactNode;
  /**
   * Replaces the plain "Edit" link with a richer toolbar.
   *
   * Homepage sections pass `<SectionControls>` so they can also be moved and
   * hidden in place. Everything else keeps the single link, which is all those
   * surfaces can act on.
   */
  controls?: React.ReactNode;
}

export default function QuickEditWrapper({
  href,
  label,
  children,
  controls,
}: QuickEditWrapperProps) {
  const { isActive } = useQuickEdit();

  if (!isActive) return children;

  if (controls) {
    return (
      <div className="group/qe relative">
        {children}
        {controls}
      </div>
    );
  }

  return (
    <div className="group/qe relative">
      {children}
      <Link
        to={href}
        className="absolute top-2 right-2 z-10 flex items-center gap-1 rounded-md bg-blue-600 px-2 py-1 text-xs font-medium text-white hover-reveal hover-reveal-qe shadow-lg hover:bg-blue-700 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
        aria-label={label}
      >
        <Pencil className="h-3 w-3" />
        Edit
      </Link>
    </div>
  );
}
